import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import { Button, Footer as FooterShell } from "@sscs/ui";
import {
  COOKIE_POLICY_ROUTE,
  DOCS_URL,
  WHATS_NEW_CHECK_RELEASE,
  WHATS_NEW_SEMVER,
} from "Constants";
import { useGetWhatsNewQuery, useUpdateWhatsNewMutation } from "Services";
import FooterLinks from "../../../../components/PublicLayout/Footer/FooterLinks";
import FooterReleaseInfo from "../../../../components/PublicLayout/Footer/FooterReleaseInfo";
import styles from "./footer.module.scss";
import { hasSeenThisRelease } from "./utils";
import WhatsNew from "./WhatsNew";

const Footer = (): React.JSX.Element => {
  const { data } = useGetWhatsNewQuery();
  const [updateWhatsNew] = useUpdateWhatsNewMutation();
  const [whatsNewOpen, setWhatsNewOpen] = useState(false);

  useEffect(() => {
    if (data && !hasSeenThisRelease(data, WHATS_NEW_SEMVER)) {
      setWhatsNewOpen(true);
    }
  }, [data]);

  const handleSeen = () => {
    // Ping backend only if it returned not seen
    if (data && !hasSeenThisRelease(data, WHATS_NEW_SEMVER)) {
      // We are not handling errors because we do not want to block users
      // from continuing to use application. The worst to happen is that
      // dialog will show up again when they refresh the page
      updateWhatsNew({
        last_seen_release: WHATS_NEW_CHECK_RELEASE,
      });
    }

    setWhatsNewOpen(false);
  };

  return (
    <FooterShell
      className={styles.container}
      left={
        <div className={styles["feature-spotlight"]}>
          <FooterReleaseInfo />
          &nbsp;-&nbsp;
          <Button variant="text" isInline onClick={() => setWhatsNewOpen(true)}>
            Feature spotlight
          </Button>
          <WhatsNew
            isOpen={whatsNewOpen}
            onConfirm={handleSeen}
            onClose={handleSeen}
          />
        </div>
      }
      right={
        <>
          <FooterLinks /> |{" "}
          <Link to={`/${COOKIE_POLICY_ROUTE}`} className={styles.link}>
            Cookies
          </Link>{" "}
          |{" "}
          <a
            href={DOCS_URL}
            target="_blank"
            rel="noreferrer"
            className={styles.link}
          >
            Help
          </a>
        </>
      }
    />
  );
};

export default Footer;
